import { QuestionInfo } from "@/services/generatedAPIs.schemas";
import { isEN } from "@/utils/i18n";
import { clsx, type ClassValue } from "clsx"
import { i18n, TFunction } from "i18next";
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (search, replacement) {
        if (typeof search === 'string') {
            // Escape special characters in the search string to use it in a RegExp
            const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            return this.replace(new RegExp(escapedSearch, 'g'), replacement);
        } else if (search instanceof RegExp) {
            // Ensure the RegExp has the global flag
            if (!search.global) {
                throw new TypeError('RegExp search must have the global flag (g).');
            }
            return this.replace(search, replacement);
        } else {
            throw new TypeError('Search value must be a string or a RegExp.');
        }
    };
}

export function getQuestionText(questionInfo: QuestionInfo, i: i18n, language: string | undefined = undefined): string {
    if (language === 'en' || (!language && isEN(i))) {
        return questionInfo.questionTextEn || "";
    } else {
        return questionInfo.questionText || "";
    }
}

export function getStandardAnswerText(questionInfo: QuestionInfo, i: i18n, language: string | undefined = undefined) {
    if (language === 'en' || (!language && isEN(i))) {
        return questionInfo.standardAnswerEn || "";
    } else {
        return questionInfo.standardAnswer || "";
    }
}

const gradeMapEN: Record<number, string> = {
    1: "Primary 1",
    2: "Primary 2",
    3: "Primary 3",
    4: "Primary 4",
    5: "Primary 5",
    6: "Primary 6",
    7: "Secondary 1",
    8: "Secondary 2",
    9: "Secondary 3",
    10: "Secondary 4",
    11: "Secondary 5",
    12: "Secondary 6",
};

const gradeMapZH: Record<number, string> = {
    1: "小學一年級",
    2: "小學二年級",
    3: "小學三年級",
    4: "小學四年級",
    5: "小學五年級",
    6: "小學六年級",
    7: "中學一年級",
    8: "中學二年級",
    9: "中學三年級",
    10: "中學四年級",
    11: "中學五年級",
    12: "中學六年級",
};

export function gradeNumberToText(grade: number, i: i18n): string | null {

    return isEN(i) ? (gradeMapEN[grade] || null) : (gradeMapZH[grade] || null);
}

export function gradeTextToNumber(gradeText: string, i: i18n): number | null {
    const gradeMap = isEN(i) ? gradeMapEN : gradeMapZH;
    for (const [key, value] of Object.entries(gradeMap)) {
        if (value === gradeText) {
            return parseInt(key);
        }
    }
    return null;
}

export function difficultyLevelToText(difficulty: number, i: i18n): string {
    if (isEN(i)) {
        switch (difficulty) {
            case 1:
                return "Easy";
            case 2:
                return "Medium";
            case 3:
                return "Hard";
            default:
                return "Unknown";
        }
    } else {
        switch (difficulty) {
            case 1:
                return "簡單";
            case 2:
                return "中等";
            case 3:
                return "困難";
            default:
                return "未知";
        }
    }
}

export function difficultyTextToLevel(difficultyText: string, i: i18n): number | null {
    if (isEN(i)) {
        switch (difficultyText) {
            case "Easy":
                return 1;
            case "Medium":
                return 2;
            case "Hard":
                return 3;
            default:
                return null;
        }
    } else {
        switch (difficultyText) {
            case "簡單":
                return 1;
            case "中等":
                return 2;
            case "困難":
                return 3;
            default:
                return null;
        }
    }
}

export function questionMistakeI18N(t: TFunction, mistake: string): string {
    switch (mistake) {
        case "Comprehension Error":
            return t("selfAssess.q3OptComprehension");
        case "Transformation Error":
            return t("selfAssess.q3OptTransformation");
        case "Mathematical Processing Error":
            return t("selfAssess.q3OptProcessing");
        case "Encoding Error":
            return t("selfAssess.q3OptEncoding");
        case "Unknown Error":
            return t("selfAssess.q3OptUnknown");
        default:
            return mistake;
    }
}

export const HOMEWORK_STATE: {tabId: string | undefined, itemId: number | undefined} = { tabId: undefined, itemId: undefined };

